import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_humanize_time = _resolveComponent("humanize-time")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
    _createVNode(_component_humanize_time, { time: _ctx.time }, null, 8, ["time"])
  ]))
}